import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.FolderPreview,
  title: 'Folder Preview',
  category: ComponentCategory.General,
};
